<template>
  <div class="card border-success-subtle shadow-sm">
    <div class="card-header bg-success-subtle py-2 d-flex justify-content-between align-items-center">
      <h6 class="mb-0 text-success-emphasis fw-bold" style="font-size:0.85rem;">
        <i v-if="origem === 'persistido'" class="bi bi-database-check me-2"></i>
        <i v-else class="bi bi-calculator me-2"></i>
        {{ titulo }}
      </h6>
      <span v-if="totalItens > 0" class="badge bg-secondary" style="font-size:0.65rem;">
        {{ itensComFiscal }} de {{ totalItens }} itens
      </span>
    </div>
    <div class="card-body py-2">
      <!-- Loading -->
      <div v-if="loading" class="text-center py-3">
        <div class="spinner-border spinner-border-sm text-info me-2"></div>
        Calculando impostos...
      </div>

      <!-- Sem dados / Impostos zerados -->
      <div v-else-if="!impostos || impostos.length === 0" class="text-center py-3 text-muted small">
        <template v-if="totalItens > 0">
          <i class="bi bi-check-circle text-success me-2"></i>
          Impostos zerados conforme perfil tributário aplicado.
        </template>
        <template v-else>
          <i class="bi bi-inbox me-2"></i>
          Nenhum imposto calculado.
        </template>
      </div>

      <!-- Grid de impostos -->
      <template v-else>
        <div class="row g-1">
          <div
            v-for="imp in impostos"
            :key="imp.chave"
            class="col-6 col-md-4 col-lg-3"
          >
            <div class="border rounded p-1 mb-1 fiscal-item-box">
              <small class="text-muted d-block" style="font-size:0.65rem;">{{ imp.label }}</small>
              <strong style="font-size:0.8rem;">{{ formatarDecimal(imp.valor) }}</strong>
              <small v-if="imp.aliquota" class="fiscal-aliquota ms-1">
                ({{ imp.aliquota }}%)
              </small>
            </div>
          </div>
        </div>
      </template>

      <!-- Totais (sempre exibidos quando há cálculo realizado) -->
      <div v-if="totalItens > 0" class="d-flex flex-wrap justify-content-between align-items-center mt-2 pt-2 border-top small">
        <div>
          <span class="text-muted">Total Impostos:</span>
          <strong class="ms-1 text-success">{{ formatarDecimal(totalImpostos) }}</strong>
        </div>
        <div>
          <span class="text-muted">Líquido a Pagar:</span>
          <strong class="ms-1 text-info">{{ formatarDecimal(valorLiquido) }}</strong>
        </div>
        <div>
          <span class="text-muted">Valor Total:</span>
          <strong class="ms-1 fw-bold">{{ formatarDecimal(valorTotal) }}</strong>
        </div>
        <div v-if="fatorImpostos">
          <span class="text-muted">Fator Impostos:</span>
          <strong class="ms-1">{{ formatarFator(fatorImpostos) }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  titulo: { type: String, default: 'Prévia dos Impostos' },
  origem: { type: String, default: 'simulacao' }, // 'simulacao' | 'persistido'
  loading: { type: Boolean, default: false },
  totalItens: { type: Number, default: 0 },
  itensComFiscal: { type: Number, default: 0 },
  impostos: { type: Array, default: () => [] },
  totalImpostos: { type: Number, default: 0 },
  valorLiquido: { type: Number, default: 0 },
  valorTotal: { type: Number, default: 0 },
  fatorImpostos: { type: Number, default: 0 }
})

const formatarDecimal = (valor) => {
  return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor || 0)
}

const formatarFator = (valor) => {
  return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(valor || 0)
}
</script>

<style scoped>
.fiscal-item-box {
  background: var(--bs-tertiary-bg);
  transition: background 0.15s ease;
}
.fiscal-item-box:hover {
  background: var(--bs-secondary-bg);
}
.fiscal-aliquota {
  font-size: 0.6rem;
  color: var(--bs-info-text-emphasis);
  font-weight: 600;
}
</style>
